export const AERIES_CONFIGURATION_LOADING = 'AERIES_CONFIGURATION_LOADING';
export const AERIES_GET_CONFIGURATION_ERROR = 'AERIES_GET_CONFIGURATION_ERROR';
export const AERIES_GET_CONFIGURATION_SUCCESS =
  'AERIES_GET_CONFIGURATION_SUCCESS';
export const AERIES_WRITE_CONFIGURATION_ERROR =
  'AERIES_WRITE_CONFIGURATION_ERROR';
export const AERIES_WRITE_CONFIGURATION_SUCCESS =
  'AERIES_WRITE_CONFIGURATION_SUCCESS';
export const AERIES_CONFIGURATION_SET_SAVE_SUCCESSFUL =
  'AERIES_CONFIGURATION_SET_SAVE_SUCCESSFUL';
export const AERIES_MAPPINGS_LOADING = 'AERIES_MAPPINGS_LOADING';
export const AERIES_GET_MAPPINGS_ERROR = 'AERIES_GET_MAPPINGS_ERROR';
export const AERIES_GET_MAPPINGS_SUCCESS = 'AERIES_GET_MAPPINGS_SUCCESS';
export const AERIES_MAPPINGS_SET_SAVE_SUCCESSFUL =
  'AERIES_MAPPINGS_SET_SAVE_SUCCESSFUL';
export const AERIES_GET_GRADES_LOADING = 'AERIES_GET_GRADES_LOADING';
export const AERIES_GET_GRADES_SUCCESS = 'AERIES_GET_GRADES_SUCCESS';
export const AERIES_GET_GRADES_ERROR = 'AERIES_GET_GRADES_ERROR';
export const AERIES_GET_LANGUAGES_LOADING = 'AERIES_GET_LANGUAGES_LOADING';
export const AERIES_GET_LANGUAGES_ERROR = 'AERIES_GET_LANGUAGES_ERROR';
export const AERIES_GET_LANGUAGES_SUCCESS = 'AERIES_GET_LANGUAGES_SUCCESS';
export const AERIES_WRITE_MAPPINGS_SUCCESS = 'AERIES_WRITE_MAPPINGS_SUCCESS';
export const AERIES_WRITE_MAPPINGS_ERROR = 'AERIES_WRITE_MAPPINGS_ERROR';
export const AERIES_MAPPINGS_CLEAR_ERRORS = 'AERIES_MAPPINGS_CLEAR_ERRORS';
export const AERIES_CONFIGURATION_CLEAR_ERRORS =
  'AERIES_CONFIGURATION_CLEAR_ERRORS';
export const AERIES_PREVIEW_LOADING = 'AERIES_PREVIEW_LOADING';
export const AERIES_GET_PREVIEW_SUCCESS = 'AERIES_GET_PREVIEW_SUCCESS';
export const AERIES_GET_PREVIEW_ERROR = 'AERIES_GET_PREVIEW_ERROR';
export const AERIES_PREVIEW_CLEAR_ERROR = 'AERIES_PREVIEW_CLEAR_ERROR';
export const AERIES_PREVIEW_RESET = 'AERIES_PREVIEW_RESET';

export const AERIES_IMPORT_STUDENT_LOADING = 'AERIES_IMPORT_STUDENT_LOADING';
export const AERIES_IMPORT_STUDENT_ERROR = 'AERIES_IMPORT_STUDENT_ERROR';
export const AERIES_IMPORT_STUDENT_SET_SAVE_SUCCESSFUL =
  'AERIES_IMPORT_STUDENT_SET_SAVE_SUCCESSFUL';
export const AERIES_MANUAL_SYNC_MANUAL_SYNC_COMPLETE =
  'AERIES_MANUAL_SYNC_MANUAL_SYNC_COMPLETE';
export const AERIES_MANUAL_SYNC_LOADING = 'AERIES_MANUAL_SYNC_LOADING';
export const AERIES_MANUAL_SYNC_STARTED = 'AERIES_MANUAL_SYNC_STARTED';
export const AERIES_MANUAL_SYNC_ERROR = 'AERIES_MANUAL_SYNC_ERROR';
export const AERIES_MANUAL_SYNC_CLEAR_ERRORS =
  'AERIES_MANUAL_SYNC_CLEAR_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/state/types.js